module.exports = __webpack_public_path__ + "static/img/relief04.56b26bf.bmp";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/relief04.bmp
// module id = 3ZvG
// module chunks = 2